/*
 * Copyright 2024 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
package cmp.navigation.di

import cmp.navigation.AppViewModel
import cmp.navigation.authenticatednavbar.AuthenticatedNavbarNavigationViewModel
import cmp.navigation.rootnav.RootNavViewModel
import org.koin.core.module.dsl.viewModelOf
import org.koin.dsl.module
import studio.oddpods.cauce.core.base.analytics.di.analyticsModule
import studio.oddpods.cauce.core.base.common.di.CommonModule
import studio.oddpods.cauce.core.base.platform.di.platformModule
import studio.oddpods.cauce.core.data.di.DataModule
import studio.oddpods.cauce.core.datastore.di.DatastoreModule
import studio.oddpods.cauce.core.intent.di.IntentModule
import studio.oddpods.cauce.core.network.di.NetworkModule
import studio.oddpods.cauce.feature.auth.di.AuthModule
import studio.oddpods.cauce.feature.dashboard.di.DashboardModule
import studio.oddpods.cauce.feature.home.di.HomeModule
import studio.oddpods.cauce.feature.onboarding.di.OnboardingModule
import studio.oddpods.cauce.feature.patients.di.PatientsModule
import studio.oddpods.cauce.feature.payments.di.PaymentsModule
import studio.oddpods.cauce.feature.reminders.di.RemindersModule
import studio.oddpods.cauce.feature.sessions.di.SessionsModule
import studio.oddpods.cauce.feature.settings.SettingsModule

object KoinModules {
    private val dataModule = module {
        includes(DataModule)
    }

    private val dispatcherModule = module {
        includes(CommonModule)
    }

    private val AppModule = module {
        includes(platformModule)

        viewModelOf(::AppViewModel)
        viewModelOf(::AuthenticatedNavbarNavigationViewModel)
        viewModelOf(::RootNavViewModel)
    }

    private val featureModule = module {
        includes(
            AuthModule,
            DashboardModule,
            HomeModule,
            OnboardingModule,
            PatientsModule,
            PaymentsModule,
            RemindersModule,
            SessionsModule,
            SettingsModule,
        )
    }

    val allModules = listOf(
        dataModule,
        dispatcherModule,
        analyticsModule,
        DatastoreModule,
        NetworkModule,
        IntentModule,
        featureModule,
        AppModule,
    )
}
